import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * NoIndexHelmet - מוסיף meta tag של noindex לנתיבי ניהול
 * 
 * מונע מגוגל לאנדקס את דפי הניהול הפנימיים (dashboard, login, settings וכו').
 * הדפים הציבוריים היחידים שצריכים להיות באינדקס הם /airport-booking ו-/rothschild-booking.
 */
const NoIndexHelmet = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {children}
    </>
  );
};

export default NoIndexHelmet;
